import PropTypes from 'prop-types';
import { getPx, compose, style } from 'styled-system';
import { fontWeights } from '../../theme';
export const caps = p => p.caps && {
  textTransform: 'uppercase'
};
export const ellipsis = p => p.ellipsis && {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};
export const getFontWeightType = textSize => {
  let fontWeightType;

  switch (textSize) {
    case 0:
      fontWeightType = 'semiBold';
      break;

    case 1:
    case 2:
      fontWeightType = 'regular';
      break;

    case 3:
    case 4:
      fontWeightType = 'semiBold';
      break;

    case 5:
    case 6:
    case 7:
      fontWeightType = 'black';
      break;

    default:
      fontWeightType = 'regular';
      break;
  }

  return fontWeightType;
};
const sizeFontSize = style({
  prop: 'textSize',
  cssProperty: 'fontSize',
  key: 'fontSizes',
  transformValue: getPx
});
const sizeLineHeight = style({
  prop: 'textSize',
  cssProperty: 'lineHeight',
  key: 'lineHeights'
});
const sizeFontWeight = style({
  prop: 'textSize',
  cssProperty: 'fontWeight',
  transformValue: props => `${fontWeights[getFontWeightType(props)]}`
});
export const textSize = compose(sizeFontSize, sizeLineHeight, sizeFontWeight);
textSize.propTypes = {
  textSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array, PropTypes.object])
};